/**
 * Spec 161 (D-161-07) — onglets d'une entrée de menu qui réunit des pages : quel onglet la page affichée ouvre, et
 * l'identifiant qui relie le panneau (le contenu de la page) à son onglet.
 */
import type { NavItem, NavOnglet } from './navigation'

function couvre(chemin: string, pathname: string): boolean {
  return pathname === chemin || pathname.startsWith(`${chemin}/`)
}

/** L'onglet de la page affichée : celui dont le chemin est le plus long préfixe de l'adresse. */
export function ongletCourant(entree: NavItem, pathname: string): NavOnglet | null {
  return (entree.onglets ?? [])
    .filter(o => couvre(o.path, pathname))
    .sort((x, y) => y.path.length - x.path.length)[0] ?? null
}

/** Identifiant de l'onglet affiché (le panneau s'y rattache par `aria-labelledby`) ; l'entrée elle-même sinon. */
export function idOngletDePage(entree: NavItem, onglet: NavOnglet | null): string {
  return onglet ? `onglet-${entree.id}-${onglet.id}` : `onglet-${entree.id}`
}
